import { Modal } from "bootstrap";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import appIcon from "../../images/app_icon_1.png";
import Carousel from "./Carousel";
import IosMessageDialog from "./IosMessageDialog";
import Splash from "./Splash";

function Auth({ baseURL, clientID, AppDisplayName, appSettings, emitEvent, setActiveTab }) {
    const navigate = useNavigate();
    const [isSplashVisible, setIsSplashVisible] = useState(true);
    const [isIos, setIsIos] = useState(false);
    const [isInstalled, setIsInstalled] = useState(false);

    useEffect(() => {
        // Check if the app is installed
        const checkInstalled = window.matchMedia("(display-mode: standalone)").matches;
        setIsInstalled(checkInstalled);

        // Listen for the appinstalled event
        const handleAppInstalled = () => {
            setIsInstalled(true);
        };

        window.addEventListener("appinstalled", handleAppInstalled);

        return () => {
            window.removeEventListener("appinstalled", handleAppInstalled);
        };
    }, []);

    useEffect(() => {
        setTimeout(function () {
            setIsSplashVisible(false);
        }, 3000);

        // Detect iOS on component mount
        detectMobileOS();
    }, []);

    const detectMobileOS = () => {
        const isIOSDevice = /iPad|iPhone|iPod/i.test(navigator.userAgent) && !window.MSStream;
        setIsIos(isIOSDevice);
    };

    const handleInstallClick = () => {
        if (isIos) {
            // Programmatically trigger the modal on iOS
            const modalElement = document.getElementById("exampleModal");
            const iosModal = new Modal(modalElement);
            iosModal.show(); // Show the modal programmatically
        } else {
            emitEvent(); // Handle non-iOS case
        }
    };

    return (
        <div style={{ position: "relative", overflow: "hidden", height: "100dvh" }}>
            <AnimatePresence>
                {isSplashVisible ? (
                    <Splash isSplashVisible={isSplashVisible} appSettings={appSettings} />
                ) : (
                    <>
                        {/* Carousel Section - takes about 60% of viewport height */}
                        <div
                            style={{
                                height: "100dvh",
                                backgroundColor: "#333333",
                                position: "relative",
                                width: "100%",
                            }}
                        >
                            <div
                                style={{
                                    height: "70dvh",
                                    backgroundColor: "#333333",
                                    position: "relative",
                                    width: "100%",
                                }}
                            >
                                <Carousel isSplashVisible={isSplashVisible} baseURL={baseURL} clientID={clientID} AppDisplayName={AppDisplayName} appIcon={appIcon} />
                            </div>
                        </div>

                        {/* Login Drawer Card - takes about 40% of viewport height */}
                        <motion.div
                            initial={{ y: "100%" }}
                            animate={{ y: "0%" }}
                            transition={{
                                duration: 0.6,
                                ease: "easeOut",
                            }}
                            style={{
                                position: "absolute",
                                bottom: 0,
                                width: "100%",
                                minHeight: "285px",
                                zIndex: 2,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "flex-end",
                            }}
                        >
                            <div
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: "32px 32px 0px 0px",
                                    boxShadow: "0px -4px 12px rgba(0, 0, 0, 0.1)",
                                    background: "linear-gradient(to top, #ffffff 0%, #f0f0f0 100%)",
                                    display: "flex",
                                    flexDirection: "column",
                                    padding: "1.5rem 1rem 0 1rem",
                                    overflowY: "auto",
                                }}
                            >
                                {/* <div
                                    style={{
                                        fontWeight: "600",
                                        fontSize: "14px",
                                        color: "black",
                                        textAlign: "center",
                                        textTransform: "capitalize",
                                        marginBottom: "1rem",
                                    }}
                                >
                                    Welcome to {AppDisplayName ? AppDisplayName : "True Value"}!
                                </div> */}

                                <div style={{ width: "100%", marginBottom: "0.9rem" }}>
                                    <button
                                        onClick={() => {
                                            navigate("/login");
                                            setActiveTab("0");
                                        }}
                                        style={{
                                            height: "44px",
                                            // boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
                                            width: "100%",
                                            borderRadius: "6px",
                                            backgroundColor: "#2C3691",
                                            color: "white",
                                            border: "none",
                                            fontSize: "13px",
                                            fontWeight: "500",
                                            cursor: "pointer",
                                            textTransform: "uppercase",
                                            letterSpacing: "0.8px",
                                        }}
                                    >
                                        Login
                                    </button>
                                </div>

                                <div style={{ width: "100%", marginBottom: "0.9rem" }}>
                                    <button
                                        onClick={() => {
                                            navigate("/login");
                                            setActiveTab("1");
                                        }}
                                        style={{
                                            height: "44px",
                                            // boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
                                            width: "100%",
                                            borderRadius: "6px",
                                            backgroundColor: "transparent",
                                            color: "black",
                                            border: "1px solid #ccc",
                                            fontSize: "13px",
                                            fontWeight: "500",
                                            cursor: "pointer",
                                            textTransform: "uppercase",
                                            letterSpacing: "0.8px",
                                        }}
                                    >
                                        Join us
                                    </button>
                                </div>

                                {!isInstalled && (
                                    <div style={{ width: "100%", marginBottom: "0" }}>
                                        <button
                                            onClick={handleInstallClick}
                                            style={{
                                                height: "44px",
                                                // boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
                                                width: "100%",
                                                borderRadius: "6px",
                                                backgroundColor: "transparent",
                                                color: "black",
                                                border: "1px solid #2C3691",
                                                fontSize: "13px",
                                                fontWeight: "500",
                                                cursor: "pointer",
                                                textTransform: "uppercase",
                                            }}
                                        >
                                            <span className="fa-regular fa-circle-down mx-1"></span>Install
                                        </button>
                                    </div>
                                )}

                                <div style={{ marginTop: "auto", width: "100%" }}>
                                    <div
                                        style={{
                                            width: "100%",
                                            height: "1px",
                                            backgroundColor: "rgba(0, 0, 0, 0.1)",
                                            margin: "0.5rem 0",
                                        }}
                                    />

                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            padding: "0.5rem 0",
                                            minHeight: "40px",
                                        }}
                                    >
                                        <span style={{ color: "#666", fontSize: "0.75rem" }}>VERSION: 1.1.5</span>

                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <span style={{ color: "#666", fontSize: "0.75rem", marginRight: "0.5rem" }}>powered by</span>
                                            <div style={{ display: "flex" }}>
                                                {"MyCom".split("").map((char, index) => (
                                                    <motion.span
                                                        key={index}
                                                        style={{
                                                            display: "inline-block",
                                                            fontWeight: "bold",
                                                            fontSize: "14px",
                                                            color: "black",
                                                        }}
                                                        animate={{
                                                            y: [20, -10, 0],
                                                            rotateX: [90, 0],
                                                            scale: [1, 1.2, 1],
                                                            color: ["#000", "#ff4081", "#2C3691"],
                                                            opacity: [0.5, 1],
                                                        }}
                                                        transition={{
                                                            duration: 1.5,
                                                            delay: index * 0.3,
                                                            repeat: Infinity,
                                                            repeatType: "loop",
                                                            repeatDelay: 2,
                                                            ease: "easeInOut",
                                                        }}
                                                    >
                                                        {char}
                                                    </motion.span>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </motion.div>

                        {isIos && <IosMessageDialog />}
                    </>
                )}
            </AnimatePresence>
        </div>
    );
}

export default Auth;
